/**
 * Build a details route without hand-concatenating query-string values.
 * URLSearchParams performs the required percent-encoding for nested URLs.
 */
export const buildDetailsPath = ({ q, start, rows, url, archiveUrl } = {}) => {
    const params = new URLSearchParams();

    if (q !== undefined) params.set('q', q);
    if (start !== undefined) params.set('start', start);
    if (rows !== undefined) params.set('rows', rows);
    if (url !== undefined) params.set('url', url);
    if (archiveUrl !== undefined) params.set('archive_url', archiveUrl);

    return `/details?${params.toString()}`;
};

